import styled from 'styled-components';

const navigationLinkStyles = `
  width: 100%;

  display: flex;
  align-items: center;

  padding: 0.7rem var(--space-m);

  border: 1px solid transparent;
  border-radius: var(--borderRadiusSmall);

  color: var(--grey4);

  font-family: var(--mainFont);
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1.35;

  text-decoration: none;

  transition:
    background-color 180ms ease,
    border-color 180ms ease,
    color 180ms ease,
    transform 180ms ease;

  span {
    display: block;
  }

  &:hover {
    border-color: var(--grey);

    background: var(--cardBackground);

    color: var(--grey7);

    transform: translateX(2px);
  }

  &.active {
    border-color: rgba(230, 139, 7, 0.16);

    background: rgba(255, 240, 194, 0.65);

    color: var(--grey7);

    box-shadow: inset 3px 0 0 var(--orange5);
  }

  &:focus-visible {
    outline: 2px solid var(--orange5);
    outline-offset: 2px;
  }
`;

export const SideContainer = styled.aside`
  width: ${({ $open }) => ($open ? '280px' : '58px')};
  min-width: ${({ $open }) => ($open ? '280px' : '58px')};

  min-height: 100vh;

  position: relative;

  display: flex;
  flex-direction: column;

  padding: ${({ $open }) =>
    $open ? 'var(--space-l) var(--space-s)' : 'var(--space-l) var(--space-xs)'};

  border-right: 1px solid var(--grey);

  background: var(--white);

  transition:
    width 220ms ease,
    min-width 220ms ease,
    padding 220ms ease;

  @media screen and (max-width: 1100px) {
    width: ${({ $open }) => ($open ? '240px' : '56px')};
    min-width: ${({ $open }) => ($open ? '240px' : '56px')};
  }

  @media screen and (max-width: 900px) {
    display: none;
  }
`;

export const DesktopSidebarLinks = styled.ul`
  width: 100%;

  display: ${({ $open }) => ($open ? 'flex' : 'none')};
  flex-direction: column;
  gap: var(--space-xxs);

  margin: var(--space-xxxl) 0 0;
  padding: 0;

  li {
    width: 100%;

    list-style: none;
  }

  .parentLink {
    padding: 0.55rem var(--space-m);
    font-weight: 800;
    color: var(--grey7);
  }

  .subLinks {
    margin: 0.25rem 0 0 0.25rem;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: var(--space-xxs);
  }

  /* nested sublinks (second level) */
  .subLinks.nested {
    margin-top: 0.125rem;
    margin-left: 0.5rem;
  }

  .subLinks.nested a {
    padding-left: calc(var(--space-m) + var(--space-s));
    font-size: 0.84rem;
    font-weight: 600;
    color: var(--grey5);
  }

  .subLinks a {
    padding-left: calc(var(--space-m) + var(--space-s));
    font-size: 0.88rem;
    font-weight: 600;
  }

  a {
    ${navigationLinkStyles}
  }
`;

export const SideToggleButton = styled.button`
  width: 32px;
  height: 32px;

  position: absolute;
  top: var(--space-l);
  right: var(--space-s);

  z-index: 10;

  display: grid;
  place-items: center;

  padding: 0;

  border: 1px solid var(--grey);
  border-radius: 50%;

  background: var(--white);

  color: var(--grey4);

  font-size: 0.75rem;

  cursor: pointer;

  box-shadow: 0 6px 18px rgba(23, 23, 23, 0.07);

  transition:
    background-color 180ms ease,
    border-color 180ms ease,
    color 180ms ease,
    transform 180ms ease,
    box-shadow 180ms ease;

  svg {
    display: block;
  }

  &:hover {
    border-color: rgba(230, 139, 7, 0.3);

    background: var(--yellow1);

    color: var(--orange5);

    box-shadow: 0 8px 20px rgba(23, 23, 23, 0.1);

    transform: translateY(-1px);
  }

  &:focus-visible {
    outline: 2px solid var(--orange5);
    outline-offset: 2px;
  }
`;

export const TabletSidebarWrapper = styled.aside`
  display: none;

  @media screen and (max-width: 900px) and (min-width: 601px) {
    width: ${({ $open }) => ($open ? '228px' : '52px')};
    min-height: ${({ $open }) => ($open ? 'auto' : '52px')};

    position: fixed;
    top: var(--space-m);
    left: var(--space-m);

    z-index: 100;

    display: flex;
    flex-direction: column;

    padding: ${({ $open }) =>
      $open
        ? 'var(--space-l) var(--space-s) var(--space-s)'
        : 'var(--space-xs)'};

    border: 1px solid var(--grey);
    border-radius: var(--borderRadius);

    background: var(--white);

    box-shadow: 0 18px 44px rgba(23, 23, 23, 0.12);

    transition:
      width 220ms ease,
      padding 220ms ease;

    ${SideToggleButton} {
      top: ${({ $open }) => ($open ? 'var(--space-l)' : 'calc(50% - 16px)')};

      right: ${({ $open }) => ($open ? 'var(--space-s)' : '10px')};
    }
  }
`;

export const TabletSidebarLinks = styled.ul`
  width: 100%;

  display: ${({ $open }) => ($open ? 'flex' : 'none')};
  flex-direction: column;
  gap: var(--space-xxs);

  margin: var(--space-xxxl) 0 0;
  padding: 0;

  li {
    width: 100%;

    list-style: none;
  }

  a {
    ${navigationLinkStyles}

    font-size: 0.86rem;
  }
`;
